/* ═══════════════════════════════════════════════════════════════
   VAWWORLD DATA — Portfolio, IPs, Services, Pipeline
   Update these to change site content (CMS-ready).
   ═══════════════════════════════════════════════════════════════ */

export const BRAND = {
  name: "VawWorld",
  tagline: "The World of Wonders",
  proposition: "A World of Cinema. Reimagined.",
  studioType: "End-to-End Animation Studio · Original IP · Global Distribution",
  offices: [
    { region: "India · HQ", address: "201, Sun Palazzo, S.B. Marg, Lower Parel, Mumbai" },
    { region: "India · Studio", address: "Plot 36-E, M.P Nagar Zone 2, Bhopal" },
    { region: "USA · Representation", address: "Lampost Films, 341 S Kenmore Ave Apt 206, Los Angeles, CA 90020, United States" },
  ],
  contactEmail: "kumar@vawworld.com",
  usaPhone: "+1 (760) 688-2280",
  usaEmail: "kumar@vawworld.com",
  reelUrl: "https://vimeo.com/442776059",
};

export const NUMBERS = [
  { value: 150, suffix: "+", label: "Crew On Floor", note: "Animators, riggers, lighters, FX, comp — under one roof" },
  { value: 200, suffix: "+", label: "Minutes Delivered / Year", note: "Feature-quality output, sustained cadence" },
  { value: 4, suffix: "", label: "Continents Delivered To", note: "USA · Europe · Korea · Japan · India" },
  { value: 60, prefix: "up to ", suffix: "%", label: "Below Traditional Budgets", note: "Same brief. Same look. Different math." },
];

export const PILLARS = [
  {
    id: "services",
    number: "01",
    kicker: "For Producers",
    title: "Animation Production",
    body: "End-to-end animated feature and series production — from treatment to DCP. We embed with your production office, run dailies, and deliver masters under NDA-first, TPN-aligned protocols.",
    bullets: ["Animated Features", "OTT & Streaming Series", "Previs · Layout · Animatic", "Full CG + VFX Delivery"],
  },
  {
    id: "ip",
    number: "02",
    kicker: "For the World",
    title: "Original IP · Development Slate",
    body: "Proprietary animated properties in active development — written, designed, and produced under one roof. Available for co-production, territorial acquisition, and MG-backed pre-sales.",
    bullets: ["Feature Screenplays", "Series Bibles", "Multi-Season Universes", "Merchandise & Publishing"],
  },
  {
    id: "distribution",
    number: "03",
    kicker: "For Partners",
    title: "Global Distribution",
    body: "Through our LA-based partners and our own OTT footprint, our content — and yours — reaches SVOD, AVOD, TVOD, broadcasters, and festival juries across North America, Europe, and Asia.",
    bullets: ["Studio & Streamer Deal-Flow", "Territory Sales · P&A", "Festival Strategy", "In-House OTT Launch"],
  },
];

export const PIPELINE_STAGES = [
  { key: "screenplay",  title: "Screenplay",         milestone: "Approved treatment",       output: "Locked script · PDF",             duration: "2–4 wks",  body: "Structure, concept, originality. You leave with a treatment your buyer can put in front of a committee." },
  { key: "storyboard",  title: "Storyboards",        milestone: "Beat-by-beat approval",    output: "Full boards · reel v1",            duration: "6–8 wks",  body: "Every beat drawn, every camera considered — long before a single asset is modeled or costed." },
  { key: "previz",      title: "Previsualization",   milestone: "Locked animatic",          output: "3D animatic · edit timing",       duration: "4–6 wks",  body: "3D animatics that lock timing, blocking, and camera language before principal production begins." },
  { key: "modeling",    title: "Modeling · Look-Dev",milestone: "Signed look-dev",          output: "Hero models · shader library",    duration: "8–10 wks", body: "Hero-quality assets, PBR materials, and look-dev that survives 4K theatrical scrutiny — one time, everywhere." },
  { key: "rigging",     title: "Rigging",            milestone: "Rig sign-off",             output: "Full rig kit · reuse-ready",       duration: "4–6 wks",  body: "Feature-grade rigs built for performance, deformation, and cross-department reuse from day one." },
  { key: "animation",   title: "Animation",          milestone: "Shot-by-shot approvals",   output: "Locked animation · playblasts",   duration: "24–32 wks",body: "Character-first animation. Weight, timing, acting choices that read on the big screen — reviewed daily, approved shot by shot." },
  { key: "fx",          title: "FX · Simulation",    milestone: "FX approvals",             output: "Sim caches · effects passes",     duration: "8–12 wks", body: "Houdini-driven simulations for fire, water, destruction, cloth, hair, and atmospherics — production-caliber, not gimmick." },
  { key: "lighting",    title: "Lighting · Look",    milestone: "Look-lock",                output: "Final lighting · LUTs",           duration: "10–14 wks",body: "Cinematic lighting design — mood, depth, direction. The invisible language of every great frame, locked with your DoP." },
  { key: "rendering",   title: "Rendering",          milestone: "Final renders delivered",  output: "EXR + AOVs · 4K",                 duration: "8–10 wks", body: "Optimized render farm with intelligent caching and shot-level dependency tracking. Faster iterations, cleaner frames." },
  { key: "comp",        title: "Compositing",        milestone: "Final comp approval",      output: "QC-ready shot masters",           duration: "8–10 wks", body: "Nuke-based finishing. Grain, glow, atmosphere — the final polish that sells reality on a large screen." },
  { key: "sound",       title: "Sound · Score · Mix",milestone: "Mix approved",             output: "Atmos mix · print master",        duration: "6–8 wks",  body: "Sound design, foley, ADR, score partnerships. Delivered to Dolby Atmos spec — one master, every territory." },
  { key: "delivery",    title: "Masters · Delivery", milestone: "Delivered to your buyer",  output: "DCP · IMF · ProRes",              duration: "2–3 wks",  body: "DCP, IMF, ProRes, broadcast and streaming masters. QC'd, versioned, platform-ready — signed over to your legal team." },
];

export const WHY_CARDS = [
  {
    title: "Lower budget. Same look.",
    body: "40–60% under a US or European feature quote. Not a lower spec — a lower number for the same 4K Dolby Atmos master.",
    icon: "gauge",
    proof: "$38–55k per finished minute",
  },
  {
    title: "Faster reviews. Fewer surprises.",
    body: "Live cloud dailies, versioned takes, threaded director notes. You see the frame the moment our supervisor sees it.",
    icon: "eye",
    proof: "First review in 2–3 days · not 10",
  },
  {
    title: "One roof. One P&L.",
    body: "150+ artists across every department in-house — no outsourced bottlenecks, no invoice pile-ups from six vendors.",
    icon: "layers",
    proof: "12 departments · one supervisor",
  },
  {
    title: "Your IP. Your files. Locked down.",
    body: "TPN-aligned network. Per-project NDAs. Every rig, source and master transferred to you on delivery. 100% ownership.",
    icon: "shield",
    proof: "TPN-aligned · full rights transfer",
  },
];

export const PORTFOLIO = [
  {
    id: "lion-mouse",
    title: "Lion & the Mouse",
    format: "Animated Short · CG",
    year: "2021",
    runtime: "07:16",
    role: "Full Production",
    synopsis: "A retelling of the timeless fable — mounted with cinematic staging, character animation, and lighting that punches well above the running time.",
    vimeoId: "590914627",
    thumb: "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1600&q=80",
    tag: "COMPLETED",
  },
  {
    id: "purple-turtle",
    title: "Purple Turtle",
    format: "Preschool Series · CG",
    year: "2015",
    runtime: "01:58 teaser",
    role: "Animation Production",
    synopsis: "A globally recognizable preschool IP with dozens of episodes delivered — the studio's proving ground for high-cadence CG series production.",
    vimeoId: "211204064",
    thumb: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=1600&q=80",
    tag: "COMPLETED",
  },
  {
    id: "hopp-hopp",
    title: "Hopp Hopp",
    format: "Series · CG",
    year: "2017",
    runtime: "01:34",
    role: "Animation Production",
    synopsis: "Character-driven comedy with tight timing, cartoon physics, and warmth. Delivered as a full pilot with a locked style guide.",
    vimeoId: "219678087",
    thumb: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1600&q=80",
    tag: "COMPLETED",
  },
  {
    id: "antz",
    title: "Antz Go Marching",
    format: "Animated Short · CG",
    year: "2021",
    runtime: "02:13",
    role: "Full Production",
    synopsis: "A stylized action piece — swarm choreography, dynamic camera, and a sense of scale that belies the runtime.",
    vimeoId: "580741420",
    thumb: "https://images.unsplash.com/photo-1518709594023-6eab9bab7b23?w=1600&q=80",
    tag: "COMPLETED",
  },
  {
    id: "kolobok",
    title: "Kolobok Story",
    format: "Series · CG",
    year: "2020",
    runtime: "—",
    role: "Animation Production",
    synopsis: "Adaptation of a beloved Eastern European folk tale — CG series work commissioned for an international broadcaster.",
    vimeoId: null,
    thumb: "https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?w=1600&q=80",
    tag: "COMPLETED",
  },
  {
    id: "borboletinha",
    title: "Borboletinha",
    format: "Series · CG",
    year: "2019",
    runtime: "—",
    role: "Animation Production",
    synopsis: "Preschool CG series produced for the Brazilian market — full-episode delivery with musical set-pieces.",
    vimeoId: null,
    thumb: "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=1600&q=80",
    tag: "COMPLETED",
  },
];

export const IN_DEVELOPMENT = [
  {
    id: "jalkumbhi",
    title: "Jalkumbhi",
    format: "Feature · CG",
    stage: "Screenplay Locked · Development Slate 2026",
    logline: "A mythic aquatic adventure — original world, original mythology, targeted at global family audiences.",
    thumb: "https://images.unsplash.com/photo-1682687982501-1e58ab814714?w=1600&q=80",
  },
  {
    id: "gopala",
    title: "Adventures of Gopala",
    format: "Series · CG",
    stage: "Bible + Pilot in Development",
    logline: "Twelve-year-old Gopala — witty, detective-minded — solves anomalies across his village with a small band of friends and unexpected allies from other worlds.",
    thumb: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1600&q=80",
  },
  {
    id: "max-luke",
    title: "Max & Luke",
    format: "Series · CG",
    stage: "Development · Style Locked",
    logline: "A cute little pig and his blue-lean rabbit uncle outwit a gang of big-bad-wolves each week — a fantasy woodland comedy for family audiences.",
    thumb: "https://images.unsplash.com/photo-1470813740244-df37b8c1edcb?w=1600&q=80",
  },
];

export const CLIENT_STAMPS = [
  "OTT PLATFORMS", "BROADCAST TV", "STUDIO PARTNERSHIPS", "STREAMING",
  "FAMILY ENTERTAINMENT", "FEATURE PRODUCERS", "PRESCHOOL", "PREMIUM YA",
];

/* ═══════════════════════════════════════════════════════════════
   PROOF — Numbers producers can quote to their greenlight committee
   ═══════════════════════════════════════════════════════════════ */
export const PROOF_METRICS = [
  { value: "$1.8M", label: "Delivered 90-min CGI feature", note: "4K master · Dolby Atmos · DCP" },
  { value: "200+", label: "Feature-minutes shipped / year", note: "Sustained cadence, four continents" },
  { value: "150+", label: "Artists on the floor", note: "12 departments · one supervisor" },
  { value: "60%", label: "Below US / European quotes", note: "Same brief. Same look. Different math." },
];

/* ═══════════════════════════════════════════════════════════════
   PROOF FILMS — Delivered titles (real posters to be swapped in)
   ═══════════════════════════════════════════════════════════════ */
export const PROOF_FILMS = [
  { title: "Feature · 2024", meta: "90-min · 4K · DCP", territory: "Streamer · Global", nda: true, poster: null },
  { title: "Series · 2023", meta: "26 × 22-min · 4K",  territory: "Broadcaster · EU",  nda: true, poster: null },
  { title: "Feature · 2022", meta: "88-min · 4K · DCP", territory: "Territorial SVOD",  nda: true, poster: null },
  { title: "Series · 2021", meta: "52 × 11-min · 4K",  territory: "AVOD · Global",     nda: false, poster: null },
  { title: "Feature · 2020", meta: "94-min · 4K",       territory: "Theatrical + SVOD", nda: true, poster: null },
  { title: "Series · 2019", meta: "40 × 7-min · 4K",   territory: "Broadcaster · APAC", nda: false, poster: null },
];

/* ═══════════════════════════════════════════════════════════════
   TESTIMONIALS — Producer quotes (real ones to be swapped in)
   ═══════════════════════════════════════════════════════════════ */
export const TESTIMONIALS = [
  {
    quote: "They hit the number, hit the date, hit the look. In this business you rarely get all three.",
    name: "Executive Producer",
    title: "Animated Feature · 2024",
    nda: true,
  },
  {
    quote: "Our supervisor was on Slack in Mumbai before we finished morning coffee in LA. Dailies felt in-house.",
    name: "Line Producer",
    title: "SVOD Original Series",
    nda: true,
  },
  {
    quote: "The budget we were quoted in Vancouver got us a pilot. What we got here was the whole season.",
    name: "Head of Development",
    title: "European Broadcaster",
    nda: true,
  },
];

export const FAQS = [
  {
    q: "How much can producers actually save?",
    a: "For a 90-minute animated feature at theatrical-grade spec, our clients see typical savings of 40–65% versus a US or European pipeline — without changing target visual quality. We build a shot-by-shot budget on discovery. No surprises.",
  },
  {
    q: "Who owns the IP and delivered assets?",
    a: "You do — 100%. Our default service agreement transfers all rights, source files, and rigs to the producer on delivery. We only retain portfolio rights, subject to your embargo terms.",
  },
  {
    q: "How do you handle NDA and asset security?",
    a: "TPN-aligned workflows, segmented networks, VLAN-isolated review environments, and per-project onboarding NDAs. Every artist signs before touching a single frame. We can walk your security officer through the setup.",
  },
  {
    q: "Can you scale a team quickly?",
    a: "Yes. We can go from a 15-artist core to 150+ artists within 4–6 weeks for a green-lit project, and scale back down without penalty. Our supervisor pool is on retainer.",
  },
  {
    q: "What software and tools do you use?",
    a: "Blender + Autodesk Maya for animation, Houdini for FX, Substance for materials, Unreal Engine for real-time review and virtual production, Nuke for compositing. We integrate with any pipeline you already run.",
  },
  {
    q: "How does the AI-assisted pipeline work?",
    a: "AI accelerates the boring parts — retopology, weight-painting, roto, layout iteration, first-pass renders. Every AI output is reviewed and hand-finished by a senior artist. We do not use AI to replace creative decisions.",
  },
  {
    q: "Do you handle full-service production or just tasks?",
    a: "Both. Producers hire us as an end-to-end partner for entire features and series, or as a specialized department (animation-only, FX-only, comp-only). Discovery calls determine the right engagement model.",
  },
  {
    q: "How are reviews and dailies handled?",
    a: "Cloud dailies with tagged shot lists, versioned takes, and threaded notes. Your director sees the same view our supervisor sees. Reviews can be scheduled or on-demand.",
  },
];

/* ═══════════════════════════════════════════════════════════════
   OTT · Start Booking Profits Early
   ═══════════════════════════════════════════════════════════════ */
export const OTT = {
  eyebrow: "REVENUE · BEFORE YOU WRAP",
  headline: "Start booking profits — early.",
  serifAccent: "before your feature even hits its theatrical window",
  body: "Every VawWorld production has an option: launch on our owned OTT footprint and syndicate across AVOD, SVOD, and TVOD partners the moment the master is QC-approved. Early traction, early revenue, early data — feeding your P&L before territorial deals close.",
  channels: [
    {
      code: "AVOD",
      name: "Ad-Supported Video-On-Demand",
      desc: "Reach the widest audience with no paywall. Ad revenue flows from day one across our AVOD partner network.",
      partners: "YouTube · Pluto · Tubi · Freevee · Roku Channel",
    },
    {
      code: "SVOD",
      name: "Subscription Video-On-Demand",
      desc: "Territorial and non-exclusive SVOD placements. Steady MG income and prestige placement on tier-one platforms.",
      partners: "Netflix · Prime · Disney+ · JioCinema · Hulu",
    },
    {
      code: "TVOD",
      name: "Transactional VOD & PVOD",
      desc: "Premium rental and purchase revenue via all major TVOD storefronts — captured shortly after theatrical.",
      partners: "iTunes · Google Play · Amazon · Vudu",
    },
  ],
  benefits: [
    "Day-one revenue from ad impressions and rentals",
    "Real-time audience data feeding your marketing strategy",
    "Weekly royalty reconciliation, transparent reporting",
    "Non-exclusive terms — you keep territorial optionality",
  ],
};

/* ═══════════════════════════════════════════════════════════════
   BLOG — Insights, Case Studies
   Featured: 90-min 3D CGI under $2M USD
   ═══════════════════════════════════════════════════════════════ */
export const BLOG_POSTS = [
  {
    id: "90-min-under-2m",
    featured: true,
    title: "How we deliver a 90-minute 3D CGI feature under $2 million USD",
    category: "Cost Playbook",
    readTime: "9 min read",
    date: "Feb 2026",
    excerpt:
      "The math behind the headline. We break down the shot-count assumptions, asset-reuse ratios, render economics, and department loading that make a sub-$2M feature real — not a marketing claim. Includes a downloadable budget model.",
    thumb: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=1600&q=80",
    tags: ["Budgeting", "Feature Films", "Pipeline"],
  },
  {
    id: "unreal-virtual-prod",
    title: "Unreal Engine in the animation pipeline — beyond the marketing reels",
    category: "Craft",
    readTime: "7 min read",
    date: "Jan 2026",
    excerpt: "Where real-time actually wins — layout, lighting review, virtual scouting — and where the traditional path still owns the frame.",
    thumb: "https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?w=1600&q=80",
    tags: ["Unreal", "Real-Time", "Look-Dev"],
  },
  {
    id: "co-pro-guide",
    title: "The producer's short guide to India-based co-production",
    category: "Deal Structure",
    readTime: "6 min read",
    date: "Dec 2025",
    excerpt: "Treaty structures, tax treatments, and the practical mechanics of running a co-pro between an LA producer and a Mumbai studio.",
    thumb: "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=1600&q=80",
    tags: ["Co-Production", "Business Affairs"],
  },
  {
    id: "asset-reuse",
    title: "Why 60% asset re-use isn't cheating — it's craftsmanship",
    category: "Pipeline",
    readTime: "5 min read",
    date: "Nov 2025",
    excerpt: "How disciplined library curation and modular rigging turn a per-shot cost problem into a per-franchise advantage.",
    thumb: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1600&q=80",
    tags: ["Asset Management", "Pipeline"],
  },
];

/* ═══════════════════════════════════════════════════════════════
   MAGAZINE — Curated Industry News (with citations)
   ═══════════════════════════════════════════════════════════════ */
export const MAGAZINE_ITEMS = [
  {
    outlet: "Variety",
    date: "Jan 2026",
    category: "Industry",
    title: "Global animation output projected to hit record production minutes in 2026",
    summary: "Streaming platform commissions and theatrical rebound push global animation minutes to an all-time high, with Asia-Pacific studios capturing an increasing share.",
    url: "https://variety.com",
    testId: "mag-variety-01",
  },
  {
    outlet: "The Hollywood Reporter",
    date: "Jan 2026",
    category: "Business",
    title: "Independent animated features finding shorter windows and stronger AVOD returns",
    summary: "New windowing patterns give producers earlier VOD revenue — a shift especially favorable to mid-budget CG features.",
    url: "https://hollywoodreporter.com",
    testId: "mag-thr-01",
  },
  {
    outlet: "Cartoon Brew",
    date: "Dec 2025",
    category: "Craft",
    title: "The rise of hybrid Blender + Unreal pipelines at boutique studios",
    summary: "Cost pressures and real-time review culture are pushing more mid-sized studios toward hybrid pipelines that were once the province of major VFX houses.",
    url: "https://cartoonbrew.com",
    testId: "mag-cbrew-01",
  },
  {
    outlet: "Animation Magazine",
    date: "Dec 2025",
    category: "Markets",
    title: "Kidscreen Summit 2026 preview — the buyer conversations that matter",
    summary: "A guide to who's shopping, who's paying, and which subgenres are getting term-sheets ahead of the February market in Miami.",
    url: "https://animationmagazine.net",
    testId: "mag-animag-01",
  },
  {
    outlet: "Deadline",
    date: "Nov 2025",
    category: "Deals",
    title: "SVOD giants deepen commitment to family and preschool CG",
    summary: "Multi-title deals and multi-season pickups signal that family CG is a stable investment category through the streaming reset.",
    url: "https://deadline.com",
    testId: "mag-deadline-01",
  },
  {
    outlet: "Screen International",
    date: "Nov 2025",
    category: "International",
    title: "MIPCOM 2025 wrap — animation drives a stronger-than-expected market",
    summary: "Kids, family, and adult animation lead trading floor activity as European broadcasters return to pre-buy discipline.",
    url: "https://screendaily.com",
    testId: "mag-screen-01",
  },
];

/* ═══════════════════════════════════════════════════════════════
   MARKETS CALENDAR — auto-filtered by date at render time
   Add new markets here with ISO startDate/endDate.
   Concluded markets are automatically hidden.
   ═══════════════════════════════════════════════════════════════ */
export const MARKETS = [
  {
    id: "kidscreen",
    name: "Kidscreen Summit",
    city: "Miami · USA",
    dates: "Feb 09 – 12, 2026",
    startDate: "2026-02-09",
    endDate: "2026-02-12",
    focus: "Kids & Family Content",
    href: "https://summit.kidscreen.com",
  },
  {
    id: "berlinale",
    name: "Berlinale · EFM",
    city: "Berlin · Germany",
    dates: "Feb 12 – 22, 2026",
    startDate: "2026-02-12",
    endDate: "2026-02-22",
    focus: "European Film Market",
    href: "https://www.efm-berlinale.de",
  },
  {
    id: "miplondon",
    name: "MIP London",
    city: "London · UK",
    dates: "Feb 23 – 25, 2026",
    startDate: "2026-02-23",
    endDate: "2026-02-25",
    focus: "TV & Content Screenings",
    href: "https://www.miplondon.com",
  },
  {
    id: "cannes",
    name: "Marché du Film · Cannes",
    city: "Cannes · France",
    dates: "May 12 – 20, 2026",
    startDate: "2026-05-12",
    endDate: "2026-05-20",
    focus: "Global Film Market",
    href: "https://www.marchedufilm.com",
  },
  {
    id: "annecy",
    name: "Annecy International Animation Festival + MIFA",
    city: "Annecy · France",
    dates: "Jun 08 – 13, 2026",
    startDate: "2026-06-08",
    endDate: "2026-06-13",
    focus: "Animation · MIFA Market",
    href: "https://www.annecyfestival.com",
  },
  {
    id: "acefair",
    name: "ACE Fair Korea",
    city: "Gwangju · South Korea",
    dates: "Sep 03 – 06, 2026",
    startDate: "2026-09-03",
    endDate: "2026-09-06",
    focus: "Asia Content & Entertainment Fair",
    href: "https://www.acefair.or.kr",
  },
  {
    id: "mipjr",
    name: "MIPJunior",
    city: "Cannes · France",
    dates: "Oct 10 – 11, 2026",
    startDate: "2026-10-10",
    endDate: "2026-10-11",
    focus: "Kids Content Market",
    href: "https://www.mipjunior.com",
  },
  {
    id: "mipcom",
    name: "MIPCOM Cannes",
    city: "Cannes · France",
    dates: "Oct 12 – 15, 2026",
    startDate: "2026-10-12",
    endDate: "2026-10-15",
    focus: "Global TV & Content Market",
    href: "https://www.mipcom.com",
  },
  {
    id: "afm",
    name: "American Film Market (AFM)",
    city: "Los Angeles · USA",
    dates: "Nov 04 – 08, 2026",
    startDate: "2026-11-04",
    endDate: "2026-11-08",
    focus: "Independent Feature Market",
    href: "https://americanfilmmarket.com",
  },
  /* ─── 2027 forward calendar (auto-surface once 2026 concludes) ─── */
  {
    id: "kidscreen-27",
    name: "Kidscreen Summit",
    city: "Miami · USA",
    dates: "Feb 08 – 11, 2027",
    startDate: "2027-02-08",
    endDate: "2027-02-11",
    focus: "Kids & Family Content",
    href: "https://summit.kidscreen.com",
  },
  {
    id: "berlinale-27",
    name: "Berlinale · EFM",
    city: "Berlin · Germany",
    dates: "Feb 11 – 21, 2027",
    startDate: "2027-02-11",
    endDate: "2027-02-21",
    focus: "European Film Market",
    href: "https://www.efm-berlinale.de",
  },
  {
    id: "cannes-27",
    name: "Marché du Film · Cannes",
    city: "Cannes · France",
    dates: "May 11 – 19, 2027",
    startDate: "2027-05-11",
    endDate: "2027-05-19",
    focus: "Global Film Market",
    href: "https://www.marchedufilm.com",
  },
  {
    id: "annecy-27",
    name: "Annecy International Animation Festival + MIFA",
    city: "Annecy · France",
    dates: "Jun 07 – 12, 2027",
    startDate: "2027-06-07",
    endDate: "2027-06-12",
    focus: "Animation · MIFA Market",
    href: "https://www.annecyfestival.com",
  },
  {
    id: "acefair-27",
    name: "ACE Fair Korea",
    city: "Gwangju · South Korea",
    dates: "Sep 02 – 05, 2027",
    startDate: "2027-09-02",
    endDate: "2027-09-05",
    focus: "Asia Content & Entertainment Fair",
    href: "https://www.acefair.or.kr",
  },
  {
    id: "mipjr-27",
    name: "MIPJunior",
    city: "Cannes · France",
    dates: "Oct 09 – 10, 2027",
    startDate: "2027-10-09",
    endDate: "2027-10-10",
    focus: "Kids Content Market",
    href: "https://www.mipjunior.com",
  },
  {
    id: "mipcom-27",
    name: "MIPCOM Cannes",
    city: "Cannes · France",
    dates: "Oct 11 – 14, 2027",
    startDate: "2027-10-11",
    endDate: "2027-10-14",
    focus: "Global TV & Content Market",
    href: "https://www.mipcom.com",
  },
  {
    id: "afm-27",
    name: "American Film Market (AFM)",
    city: "Los Angeles · USA",
    dates: "Nov 03 – 07, 2027",
    startDate: "2027-11-03",
    endDate: "2027-11-07",
    focus: "Independent Feature Market",
    href: "https://americanfilmmarket.com",
  },
];
